'use client'

import { type ReactNode, useCallback, useEffect, useRef, useState } from 'react'

import Autoplay from 'embla-carousel-autoplay'

import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselNext,
  CarouselPrevious,
} from './CarouselPrimitive.component'

export const CarouselBase = ({
  children,
  isCourseCarousel = false,
}: {
  children: ReactNode
  isCourseCarousel?: boolean
}) => {
  const autoplayRef = useRef(
    Autoplay({
      delay: 5000,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    })
  )

  const [mobileApi, setMobileApi] = useState<CarouselApi | null>(null)
  const [current, setCurrent] = useState(0)
  const [total, setTotal] = useState(0)

  const plugins = useCallback(() => [autoplayRef.current], [])

  useEffect(() => {
    if (!mobileApi) return

    const onSelect = () => {
      setCurrent(mobileApi.selectedScrollSnap())
      setTotal(mobileApi.scrollSnapList().length)
    }

    mobileApi.on('select', onSelect)
    // Initialize
    onSelect()

    return () => {
      mobileApi.off('select', onSelect)
    }
  }, [mobileApi])

  return (
    <>
      <div
        className={`relative hidden flex-col ${isCourseCarousel ? `min-[1112px]:flex` : 'xl:flex'}`}
      >
        <Carousel
          opts={{
            align: 'center',
            slidesToScroll: 1,
            loop: false,
          }}
          className="w-full"
          plugins={plugins()}
        >
          <CarouselPrevious className="top-[-5rem]" variant="tertiary" />
          <CarouselNext className="top-[-5rem]" variant="tertiary" />
          <CarouselContent className="ml-0">{children}</CarouselContent>
        </Carousel>
      </div>
      <div
        className={`relative flex flex-col ${isCourseCarousel ? `min-[1112px]:hidden` : 'xl:hidden'}`}
      >
        <Carousel
          opts={{
            align: 'center',
            slidesToScroll: 1,
            loop: false,
          }}
          className="w-full"
          plugins={plugins()}
          setApi={setMobileApi}
        >
          <CarouselContent className="ml-0">{children}</CarouselContent>
        </Carousel>
        <div className="h-1 w-full overflow-hidden bg-academy-blue-50">
          <div
            className="h-full bg-academy-blue-400 transition-all duration-300 ease-in-out"
            style={{
              width: `${total > 0 ? (current / (total - 1)) * 100 : 0}%`,
            }}
          />
        </div>
      </div>
    </>
  )
}
